import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Layout,
  notification,
  Popconfirm,
  Menu,
  Dropdown,
} from "antd";
import { useNavigate, Link } from "react-router-dom";
import { Button, Row, Form, Input, Col, Select, Collapse, Tag, Modal } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import Subtenant from "../common/Models/Subtenants/Subtenants";
import { DeleteOutlined, DotChartOutlined, MinusCircleTwoTone, MoreOutlined, PlusCircleTwoTone, UserOutlined, UserSwitchOutlined } from "@ant-design/icons";
import SubtenantApi from "../common/Apis/SubtenantApi";
import UserApi from "../common/Apis/UserApi";
import InviteUsersModal from "./InviteUsersModal";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const { confirm } = Modal;
const SubtenantsUnterUser = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Tenants, setTenantsUnterUser] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const [visible, setVisible] = useState(false);

  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getTenants();
    PageLoading();

  }, []);

  const handleInvite = (emails) => {
    console.log("Invited:", emails);
    // message.success(`Invited ${emails.length} users`);
    setVisible(false);
  };

  const openUserInviteModal = () => {
    setVisible(true);
  }

  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);
  const getTenants = useCallback(() => {
    UserApi.tenantUnterUsers(id)
      .then((response) => {
        setTenantsUnterUser(response.payloadDto?.sort((a, b) => b.id - a.id));
        setTotalElements(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleRemovefilterTenant = (FilterTenantIndex) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant.splice(FilterTenantIndex, 1);
    setFilterTenants(newfilterTenant);
    if (FilterTenantIndex == 0) {
      getTenants();
    }
  };
  const handleClear = () => {
    getTenants();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterTenants([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const [filterTenant, setFilterTenants] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterTenants = () => {
    setFilterTenants([
      ...filterTenant,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterTenant
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");


    let filderData = window.btoa("componentCode=USER&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, 100)
      .then((response) => {
        setTenantsUnterUser(response.payloadDto);
      })
      .catch((err) => { });
  };
  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].title = value;
    setFilterTenants(newfilterTenant);
  };
  const handleChangeAnswertype = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].answerType = value;
    setFilterTenants(newfilterTenant);
  };

  const handleChangename = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].name = value;
    setFilterTenants(newfilterTenant);
  };


  const handleDeleteUser = (userId) => {
    UserApi.DeleteUsers(userId)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getTenants();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = Tenants.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const showDeleeConfirm = (user) => {
    confirm({
      title: `Are you sure you want to delete user "${user.email}"?`,
      content: "This action can not be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleDeleteUser(user.id);
      },
      onCancel() {
        console.log("Deactivation cancelled");
      },
    });
  };

  const renderTableRows = () => {
    return paginatedData.map((item) => (
      <tr key={item.id} className="text-center">
        <td>{item.firstName} {item.firstName}</td>
        <td>{item.email}</td>
        <td style={{ width: "22%" }} className="text-center">
          {item?.aptitudeTestStatus === "PENDING" && <Tag color="blue">{item?.aptitudeTestStatus.toUpperCase()}</Tag>}
          {item?.aptitudeTestStatus === "COMPLETED" && <Tag color="green">{item?.aptitudeTestStatus.toUpperCase()}</Tag>}
        </td>
        <td>
          <div
            className="d-flex justify-content-center align-items-center">
            <div className="dropdown">
              <Button
                type="default"
                className="dropdown-toggle"
                id={`actionMenu-${item.id}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </Button>
              <ul
                className="dropdown-menu"
                aria-labelledby={`actionMenu-${item.id}`}
              >
                {item?.aptitudeTestStatus === "COMPLETED" && <li>
                  <Button
                    type="button"
                    className="dropdown-item"
                  // onClick={() => showDeleteModal(item)}
                  >
                    <Link to={`/users/health?email=${item.email}&name=${item?.firstName} ${item.lastName}`} className="userLink" >Health</Link>
                  </Button>
                </li>}
                {decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'DELETE_USER') && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                    onClick={() => showDeleeConfirm(item)}
                    >
                      Delete
                    </Button>
                  </li>}
              </ul>
            </div>
          </div>
          {/* {item?.email !== "admin@admin.com" && (
            <>
              <div className="d-flex justify-content-center">
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item
                        key="edit"
                        className={`${item?.firstName ? "" : "d-none"}`}>
                        <Link to={`/users/health?email=${item.email}&name=${item?.firstName} ${item.lastName}`} className="userLink" >  <DotChartOutlined /> Health</Link>
                      </Menu.Item>

                      <Menu.Item
                        key="History"

                        className={`${item?.firstName ? "" : "d-none"}`}>
                        <Link to={`/users/user-role?email=${item.email}`} className="userLink"  >  <UserOutlined /> User Role</Link>


                      </Menu.Item>
                      <Menu.Item
                        key="stock"
                        className={decodedToken?.permissions?.some(
                          (permission) => permission?.authority === 'DELETE_USER'
                        ) ? '' : 'd-none'}
                      >
                        <Popconfirm
                          title="Are you sure ?"
                          description="Do you really want to delete this User ?"
                          okText="Yes"
                          onConfirm={() => handleDeleteUser(item.id)}
                          placement="topRight"
                          className="w-100"
                          cancelText="No"
                        >

                          <DeleteOutlined />     Delete

                        </Popconfirm>
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                  placement="bottom"
                >
                  <div className="action-circle">
                    <MoreOutlined />
                  </div>
                </Dropdown>
              </div>


            </>
          )} */}
        </td>
        {/* <td style={{ width: "15%" }}>
          <div className="d-flex ">
          <Link
              to={`/sub-tenants/edit-sub-tenants?id=${item?.id}`}
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'EDIT_SUB_TENANT'
              ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
            >
              <EditOutlined />
              Edit
            </Link> 
            <Popconfirm
              title="Are you sure ?"
              description="Do you really want to delete this Subtenants ?"
              okText="Yes"
              onConfirm={() => handleDeleteSubtenants(item.id)}
              placement="topRight"
              className="w-100"
              cancelText="No"
            >
              <Link
                to={``}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'DELETE_SUB_TENANT'
                ) ? 'btn btn-primary btn-back table-action icon-center ' : 'd-none'}
              >
                <DeleteOutlined />
                Delete
              </Link>
            </Popconfirm>
          </div>

        </td> */}
      </tr>
    ));
  };

  const handleDeleteSubtenants = (SubtenantID) => {
    SubtenantApi.DeletesubtenantsApi(SubtenantID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        getTenants();
        PageLoading();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };


  const [modalVisible, setModalVisible] = useState(false);

  const handleOpenAddModal = () => {
    setModalVisible(true);
  };

  const handlCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass "
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterTenant.map((input, filterTenantIndex) => (
                    <div key={filterTenantIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterTenantIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterTenantIndex, value)
                              }
                              options={[
                                { value: "firstName", label: "First Name" },
                                { value: "lastName", label: "Last Name" },
                                { value: "email", label: "Email" },

                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          {filterTenant[filterTenantIndex].title ==
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col span={5}>
                          {filterTenant[filterTenantIndex].title ==
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterTenantIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterTenants}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterTenant(filterTenantIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            {/* <Button
              href={"/users/invite-sub-tenants-users?id=" + id}
              className='btn btn-primary btn-save m-0 my-2'
            >
              Add New User
            </Button> */}
            <Button type="primary" style={{ padding: '5px 24px', fontSize: '18px' }} onClick={() => openUserInviteModal()}>
              Invite New User
            </Button>
            <table className="table Tenants-table">
              <thead>
                <tr>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th className="text-center">Status</th>
                  <th className="text-center"></th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={pageSize}
            />
          )}
          </div>
        </Content>
        <Subtenant
          visible={modalVisible}
          onClose={handlCloseModal}
        />
        <InviteUsersModal
          visible={visible}
          onCancel={() => setVisible(false)}
          onInvite={handleInvite}
          subTenantId={id}
        />
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default SubtenantsUnterUser;